import styled, { css } from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getHeightForRenderedTilesSection } from 'LayoutBuilderUI/components/panels/sidebar/utils/sizing';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SHOW_MORE_BUTTON_HEIGHT = 40;
const CustomWrapper = styled.div.withConfig({
  displayName: "ExpandableSectionContentWrapper__CustomWrapper"
})(({
  numberOfTiles,
  offset,
  tilesPerRow,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["position:relative;display:flex;flex-direction:row;flex-wrap:wrap;gap:", ";block-size:", "px;"], theme.space[100], getHeightForRenderedTilesSection({
    numberOfTiles,
    offset,
    tilesPerRow
  }));
});
const ExpandableSectionContentWrapper = ({
  numberOfTiles,
  tilesPerRow,
  children,
  shouldRenderShowMore,
  onShowMoreClick
}) => {
  const offset = shouldRenderShowMore ? SHOW_MORE_BUTTON_HEIGHT : 0;
  return /*#__PURE__*/_jsxs(CustomWrapper, {
    numberOfTiles: numberOfTiles,
    offset: offset,
    tilesPerRow: tilesPerRow,
    children: [children, shouldRenderShowMore && /*#__PURE__*/_jsxs(Button, {
      onClick: onShowMoreClick,
      use: "transparent",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.addPanel.showAll"
      })]
    })]
  });
};
export default ExpandableSectionContentWrapper;